import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboard from "@/pages/AdminDashboard";
import PrivacyPage from "@/pages/PrivacyPage";
import VotingGuidePage from "@/pages/VotingGuidePage";
import KomunikatDetailPage from "@/pages/KomunikatDetailPage";
import WiadomoscDetailPage from "@/pages/WiadomoscDetailPage";
import UchwalaDetailPage from "@/pages/UchwalaDetailPage";
import ReportPage from "@/pages/ReportPage";
import ReportTrackingPage from "@/pages/ReportTrackingPage";
import OgloszeniaPage from "@/pages/OgloszeniaPage";
import OgloszenieDetailPage from "@/pages/OgloszenieDetailPage";
import OgloszenieDodajPage from "@/pages/OgloszenieDodajPage";
import MapaPage from "@/pages/MapaPage";
import UnsubscribePage from "@/pages/UnsubscribePage";
import GoogleAnalytics from "@/components/GoogleAnalytics";

// Configurable admin slug – defaults to /adm1n. Override via REACT_APP_ADMIN_PATH.
// Bots scanning for "/admin" won't find anything (no route is registered).
export const ADMIN_PATH = (process.env.REACT_APP_ADMIN_PATH || "/adm1n").replace(/^([^/])/, "/$1");

function App() {
    return (
        <BrowserRouter>
            <GoogleAnalytics />
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/komunikat/:id" element={<KomunikatDetailPage />} />
                <Route path="/wiadomosc/:id" element={<WiadomoscDetailPage />} />
                <Route path="/uchwala/:id" element={<UchwalaDetailPage />} />
                <Route path="/jak-glosowac" element={<VotingGuidePage />} />
                <Route path="/zglos-usterke" element={<ReportPage />} />
                <Route path="/zgloszenie/:ticket" element={<ReportTrackingPage />} />
                <Route path="/polityka-prywatnosci" element={<PrivacyPage />} />
                <Route path="/ogloszenia" element={<OgloszeniaPage />} />
                <Route path="/ogloszenia/dodaj" element={<OgloszenieDodajPage />} />
                <Route path="/ogloszenie/:id" element={<OgloszenieDetailPage />} />
                <Route path="/mapa" element={<MapaPage />} />
                <Route path="/wypisz" element={<UnsubscribePage />} />
                <Route path={ADMIN_PATH} element={<AdminLoginPage />} />
                <Route path={`${ADMIN_PATH}/dashboard`} element={<AdminDashboard />} />
            </Routes>
            <Toaster position="top-right" richColors />
        </BrowserRouter>
    );
}

export default App;
